import { Add, FileDownloadOutlined, MoreVert } from "@mui/icons-material";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { MouseEvent, useState } from "react";

export type ReportTableActionsMenuProps = {
  canCreate: boolean;
  createLabel: string;
  createTooltip?: string;
  downloadLabel?: string;
  downloadTooltip?: string;
  onCreate: () => void;
  onDownload?: () => void;
};

export const ReportTableActionsMenu = ({
  canCreate,
  createLabel,
  createTooltip,
  downloadLabel,
  downloadTooltip,
  onCreate,
  onDownload,
}: ReportTableActionsMenuProps) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | undefined>();

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => setMenuAnchor(undefined);

  const handleMenuAction = (action: () => void) => {
    closeMenu();
    action();
  };

  return (
    <>
      <Tooltip title="More actions" placement="top">
        <IconButton size="small" aria-label="table actions" onClick={openMenu}>
          <MoreVert fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={closeMenu}
      >
        {canCreate && (
          <MenuItem
            title={createTooltip}
            onClick={() => handleMenuAction(onCreate)}
          >
            <ListItemIcon>
              <Add fontSize="small" />
            </ListItemIcon>
            <ListItemText>{createLabel}</ListItemText>
          </MenuItem>
        )}
        {onDownload && downloadLabel && (
          <MenuItem
            title={downloadTooltip}
            onClick={() => handleMenuAction(onDownload)}
          >
            <ListItemIcon>
              <FileDownloadOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{downloadLabel}</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
